import { Route, createBrowserRouter, createRoutesFromElements } from "react-router-dom";

import { Airdrops } from "@/pages/Airdrops";
import { Dashboard } from "@/pages/Dashboard";
import { Home } from "@/pages/Home";
import { TotalScore } from "@/pages/TotalScore";
import { Providers } from "@/providers";

import { APP_ROUTES } from "./constants";
import { Promotion } from "@/pages/Promotion";
export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Providers />}>
      <Route path={APP_ROUTES.HOME} element={<Home />} />
      <Route path={APP_ROUTES.DASHBOARD} element={<Dashboard />} />
      <Route path={APP_ROUTES.AIRDROPS} element={<Airdrops />} />
      <Route path={APP_ROUTES.TOTAL_TRUST_SCORE} element={<TotalScore />} />
      <Route path={APP_ROUTES.PROMOTION} element={<Promotion />} />
    </Route>,
  ),
);
